import * as React from "react";
const SvgCheckmarkCircle20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2ZM0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9Zm7.5 4.414L13.914 7 12.5 5.586l-5 5-2-2L4.086 10 7.5 13.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgCheckmarkCircle20Px;
